<div class="bloc_offers">
    <div class="bloc_offers_filters">
        <div>
            <div class="filters">
                <app-core-offer-creator-filter></app-core-offer-creator-filter>
            </div>
            <div class="filters_checked">

                @for(filter of currentFilters; track filter) {

                    @if(filter.formattedValue) {
                        <span class="filter" (mousedown)="removeFilter(filter.field)">
                            <span>{{ filter.formattedValue }}</span>
                            <span class="close"><mat-icon>close</mat-icon></span>
                        </span>
                    }
                }

            </div>
        </div>
    </div>
    <div class="offers_list" style="padding-top: 32px">
        <div class="content_offers">
            <div class="row marges">
                @for(item of items; track item) {
                    <div class="col_12 col_md_6 col_lg_4 content_card">
                        <app-core-offer-creator-card [item]="item" [mode]="mode"></app-core-offer-creator-card>
                    </div>
                }
            </div>
            @if(sourceLoaded && hasMoreItems) {
                <div class="row more_offer">
                    <div class="col x_center">
                        <button class="btn_cta btn_highlight" type="button" (click)="loadMoreItems()">
                            {{ 'offerCreator.more.value' | translate }}
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
